import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessProductCategoryManagerHandler } from '../../providers/business-product-category-handler';
import { BusinessProductCategoryManagerPage } from '../business-product-category-manager/business-product-category-manager';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-product-category-list',
  templateUrl: 'business-product-category-list.html',
})
export class BusinessProductCategoryListPage {
	categories: any;
	hasCategories: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	loadingMsg: any = "Loading...";
	isRefreshing: boolean = false;
	lastRequestReturnedValues: boolean = false;

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

  	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public categoryManagerHandler: BusinessProductCategoryManagerHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;
  	}

  	ionViewWillEnter() {
		this.load(null);
	}	

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isRefreshing = true;

		this.params.page++;

		this.load(()=>{
			this.isRefreshing = false;
			
			infiniteScroll.complete();
		});
	}		

	create(){
	    this.navCtrl.push(BusinessProductCategoryManagerPage, {
	      category: {}
	    });		
	}

	manage($e, category){
	    this.navCtrl.push(BusinessProductCategoryManagerPage, {
	      category: category
	    });				
	}

	load(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;

		this.params.cb = (categories)=>{
			this.categories = categories;

			this.hasCategories = this.categories.length>0;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		}
		
		this.categoryManagerHandler.getProductCategories(this.params)
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-product-category-list/business-product-category-list.ts